import service from '@/services/singleProduct';
import serviceCategory from '@/services/category';
import mediaCenterService from '@/services/mediaCenter';
import { uploadToOSS, uploadToS3 } from '@/utils/files';
import format from '@/utils/format';
import imagesUtil from '@/utils/images';
import messageUtil from '@/utils/message';
import spinner from '@/utils/spinner';

const CDN_URL = 'https://cdn.dsmcdn.com/';

const flatten = (arr, formatArr, parent) => arr.reduce((flat, toFlatten) => {
  const paths = [
    ...(parent.paths || []),
    ...[toFlatten.Name],
  ];
  const ids = [
    ...(parent.ids || []),
    ...[toFlatten.Id],
  ];
  if (toFlatten.Nodes && toFlatten.Nodes.length <= 0) {
    formatArr.push({
      value: toFlatten.Id,
      label: toFlatten.Name,
      Id: toFlatten.Id,
      Name: toFlatten.Name,
      path: paths.join(' > '),
      ids: ids,
      paths,
      values: ids,
    });
    return formatArr;
  }
  toFlatten.path = paths.join(' > ');
  toFlatten.paths = paths;
  toFlatten.ids = ids;
  return flatten(toFlatten.Nodes || [], formatArr, toFlatten);
}, []);
export default {
  namespaced: true,
  state: {
    categories: [],
    flatCategories: [],
    varianter: null,
    varianters: [],
    slicers: [],
    others: [],
    formData: {
      productCategory: {
        paths: [],
        ids: [],
      },
      productSlicers: {},
      productVarianters: [{
        barcode: '',
        attrs: {},
      }],
      productOthers: {},
      productImages: [],
    },
  },
  getters: {
    getFormData (state) {
      return state.formData;
    },
    getFlatCategories (state) {
      return state.flatCategories;
    },
    getCategories (state) {
      return state.categories;
    },
    getSlicers (state) {
      return state.slicers;
    },
    getVarianters (state) {
      return state.varianters;
    },
    getVarianter (state) {
      return state.varianter;
    },
    getOthers (state) {
      return state.others;
    },
  },
  mutations: {
    getProductCategories (state, categories) {
      state.categories = categories;
      state.flatCategories = flatten(categories, [], {});
    },
    getSelectedCategoryAttributes (state, attributes) {
      state.slicers = [];
      state.others = [];
      state.varianters = [];
      state.varianter = null;

      const categoryAttributes = attributes.categoryAttributes || [];

      for (let i = 0; i < categoryAttributes.length; i += 1) {
        const attr = categoryAttributes[i];
        const field = {
          id: attr.attribute.id,
          name: attr.attribute.name.toUpperCase(),
          validation: { required: attr.required },
          varianter: attr.varianter,
          slicer: attr.slicer,
          inputType: attr.allowCustom && attr.attributeValues.length === 0 ? 'input' : 'Select',
          className: attr.allowCustom,
          props: {
            name: `field-${attr.attribute.id}`,
            'data-vv-as': attr.attribute.name,
          },
        };
        const attributColor = attr.attribute.id === 47;
        if (attributColor) {
          field.inputType = 'input';
          field.validation.max = 50;
          field.className = true;
        }
        if (!attr.allowCustom && !attributColor) {
          field.props.options = attr.attributeValues.map(val => ({
            id: val.id,
            label: val.name,
          }));
        }
        if (field.varianter && !field.slicer) {
          if (!state.varianters.length) {
            state.varianter = field;
          } else {
            state.varianters.push(field);
          }
        } else if (!field.varianter && field.slicer) {
          state.slicers.push(field);
        } else {
          state.others.push(field);
        }
      }
    },
    setFormData (state, formData) {
      state.formData = {
        ...state.formData,
        ...formData,
      };
    },
    async createProductBarcodeBulk (state, onSuccess) {
      const items = [];
      spinner.start();
      try {
        let productImages = [];
        const filePrepareRequests = [];
        if (state.formData.productImages.length > 0 && state.formData.productVarianters.length) {
          const images = state.formData.productImages;
          for (let i = 0; i < images.length; i += 1) {
            const image = images[i];
            if (!image.url) {
              const filePrepareRequest = new Promise((resolve, reject) => {
                service.getProductImagePath(image.name).then(async (signature) => {
                  try {
                    await uploadToOSS(signature, image, true);
                    resolve(signature.downloadUrl);
                  } catch (e) {
                    try {
                      const responseS3 = await mediaCenterService.prepareToUploadS3(image.name);
                      signature = responseS3[0];
                      await uploadToS3(signature.uploadUrl, image);
                      signature.objectKey = String(signature.downloadUrl).replace(CDN_URL, '');
                    } catch (e) {
                      reject(new Error('Bir hata oluştu şu anda resim yükleyemezsiniz'));
                    }
                  }
                });
              });
              filePrepareRequests.push(filePrepareRequest);
            } else {
              productImages.push({
                url: imagesUtil.clearCdnImage(state.formData.productImages[i].url),
              });
            }
          }
        }
        if (filePrepareRequests.length > 0) {
          try {
            const uploadResponse = await Promise.all(filePrepareRequests);
            const images = uploadResponse.map(item => ({ url: item }));
            productImages = [...productImages, ...images];
          } catch {
            throw new Error('Bir hata oluştu şu anda resim yükleyemezsiniz');
          }
        }
        for (let i = 0; i < state.formData.productVarianters.length; i += 1) {
          const varianter = state.formData.productVarianters[i];
          const item = {};
          item.barcode = varianter.barcode;
          item.title = state.formData.productName;
          item.productMainId = state.formData.productModelCode;
          item.brandId = state.formData.productBrand.id;
          item.brandName = state.formData.productBrand.label;
          item.categoryId = state.formData.productCategory.Id;
          item.quantity = parseInt(varianter.quantity, 10);
          item.stockCode = varianter.stockCode;
          item.dimensionalWeight = 0;
          item.description = (state.formData.productDescription === '' ? item.title : state.formData.productDescription);
          item.currencyType = 'TRY';
          item.listPrice = format.priceToNumber(varianter.listPrice);
          item.salePrice = format.priceToNumber(varianter.salePrice);
          item.vatRate = parseInt(varianter.vatRate.value || 0, 10);
          item.cargoCompanyId = 0;
          item.attributes = [];
          item.images = productImages;
          const attrArray = Object.keys(varianter.attrs);
          for (let j = 0; j < attrArray.length; j += 1) {
            const attrId = attrArray[j];
            item.attributes.push({
              attributeId: parseInt(attrId),
              attributeValueId: varianter.attrs[attrId].id ? varianter.attrs[attrId].id : null,
              customAttributeValue: !varianter.attrs[attrId].id ? varianter.attrs[attrId] : '',
            });
          }
          const slicerArray = Object.keys(state.formData.productSlicers);
          for (let j = 0; j < slicerArray.length; j += 1) {
            const slicerId = slicerArray[j];
            item.attributes.push({
              attributeId: parseInt(slicerId),
              attributeValueId: state.formData.productSlicers[slicerId].id ? state.formData.productSlicers[slicerId].id : null,
              customAttributeValue: !state.formData.productSlicers[slicerId].id ? state.formData.productSlicers[slicerId] : '',
            });
          }
          const otherArray = Object.keys(state.formData.productOthers);
          for (let j = 0; j < otherArray.length; j += 1) {
            const otherId = otherArray[j];
            item.attributes.push({
              attributeId: parseInt(otherId),
              attributeValueId: state.formData.productOthers[otherId].id ? state.formData.productOthers[otherId].id : null,
              customAttributeValue: !state.formData.productOthers[otherId].id ? state.formData.productOthers[otherId] : '',
            });
          }
          items.push(item);
        }

        await service.createProductNotExisting(items);
        onSuccess && onSuccess();
      } catch (e) {
        messageUtil.error(e.message);
      } finally {
        spinner.done();
      }
    },
    resetAttributes (state) {
      state.formData = {};
      state.formData.productSlicers = {};
      state.formData.productOthers = {};
      state.formData.productVarianters = [{
        barcode: '',
        attrs: {},
      }];
      state.formData.productImages = [];
    },
  },
  actions: {
    async getProductCategories ({ commit }) {
      const categories = await serviceCategory.getCategories();
      commit('getProductCategories', categories.Categories);
    },
    async getSelectedCategoryAttributes ({ commit }, categoryId) {
      const attributes = await serviceCategory.getCategoryAttributes(categoryId);
      commit('getSelectedCategoryAttributes', attributes);
    },
    setFormData ({ commit }, formData) {
      commit('setFormData', formData);
    },
    async createProductBarcodeBulk ({ commit }, onSuccess) {
      commit('createProductBarcodeBulk', onSuccess);
    },
    resetAttributes ({ commit }) {
      commit('resetAttributes');
    },
    async createProductBarcode ({ commit }, formData) {
      const data = {};
      data.barcode = formData.barcode;
      data.title = formData.title;
      data.productMainId = formData.productMainId;
      data.brandId = formData.brandId;
      data.categoryId = formData.categoryId;
      data.quantity = parseInt(formData.quantity, 10);
      data.stockCode = formData.stockCode;
      data.dimensionalWeight = 0;
      data.description = (formData.description === '' ? formData.title : formData.description);
      data.currencyType = 'TRY';
      data.listPrice = format.priceToNumber(formData.salePrice);
      data.salePrice = format.priceToNumber(formData.salePrice);
      data.vatRate = parseInt(formData.vatRate ? formData.vatRate : 0, 10);
      data.cargoCompanyId = formData.cargoCompanyId;
      data.returningAddressId = formData.returningAddressId;
      data.images = formData.productImages;
      data.attributes = formData.productAttributes.map(attr => ({
        attributeId: attr.id,
        attributeValueId: attr.valueId ? attr.valueId : null,
        customAttributeValue: !attr.valueId ? attr.customValue : null,
      }));

      await service.createProduct(data);
    },
  },
};
